module.exports = __webpack_public_path__ + "static/media/defaultAvatar5.b43567a2.svg";